import { FileParameter, ImportCo2MaterialType, ImportCo2MaterialTypeFailure, ImportCo2MaterialTypesResponse, TemplateType, TemplatesClient, Co2MaterialLibraryScope } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation } from "@tanstack/react-query";

const templatesClient = new TemplatesClient(undefined, axios);

export const useUploadTemplate = (options?: any) => {
  return useMutation<any>({
    ...options,
    mutationFn: async ({
      templateType,
      commitChanges,
      commitAfterWarning,
      fileParameter,
      isDefault,
      scope,
      co2MaterialLibraryParentId,
    }: {
      templateType: TemplateType;
      commitChanges: boolean;
      commitAfterWarning: boolean;
      fileParameter: FileParameter;
      isDefault?: boolean;
      scope?: Co2MaterialLibraryScope;
      co2MaterialLibraryParentId?: string | null;
    }) => {
      return await templatesClient.uploadTemplate(
        templateType,
        commitChanges,
        commitAfterWarning,
        isDefault,
        null,
        null,
        scope ?? null,
        co2MaterialLibraryParentId ?? null,
        fileParameter,
      );
    },
    onSuccess: async (data: ImportCo2MaterialTypesResponse, variables: any) => {
      const committed = variables.commitChanges || variables.commitAfterWarning;
      if (committed) {
        await queryClient.resetQueries({ queryKey: ["materialLibraries"], exact: false });
        await queryClient.resetQueries({ queryKey: ["materialTypes"], exact: false });
        await queryClient.resetQueries({ queryKey: ["materialTypesQuery"], exact: false });
        await queryClient.resetQueries({ queryKey: ["materialTypeOptions"], exact: false });
        options?.onSuccess?.(data, variables);
      } else {
        // When we are only doing validation (commitChanges = false) then we do get
        // the validation results back
        data.importCo2MaterialTypeResult?.successItems?.forEach((item: ImportCo2MaterialType) => {
          item.sourceData = JSON.parse(item.sourceData || "{}");
        });
        data.importCo2MaterialTypeResult?.failureItems?.forEach((item: ImportCo2MaterialTypeFailure) => {
          if (item.importCo2MaterialType) {
            item.importCo2MaterialType.sourceData = JSON.parse(item.importCo2MaterialType.sourceData || "{}");
          }
        });
        options?.onSuccess?.(data);
      }
    }
  });
};